export default function Modals () {
  const BREAKING_MODAL = new Modal('breaking-modal', '.open-breaking-modal, a[href="#open-breaking-modal"]')
}

class Modal {
  constructor (ELEMENT, SELECTOR) {
    this.ELEMENT = document.getElementById(ELEMENT)
    if (!this.ELEMENT) return

    this.OPEN_BUTTONS = document.querySelectorAll(SELECTOR)
    if (this.OPEN_BUTTONS.length === 0) return

    this.CLOSE_BUTTONS = this.ELEMENT.querySelectorAll('.mtt-modal__close, .mtt-modal__overlay')
    this.eventListeners()
  }

  eventListeners () {
    // Open modal
    for (let i = 0; i < this.OPEN_BUTTONS.length; i++) {
      this.OPEN_BUTTONS[i].addEventListener('click', this.openModal.bind(this))
    }

    // Close modal
    if (this.CLOSE_BUTTONS.length) {
      for (let i = 0; i < this.CLOSE_BUTTONS.length; i++) {
        this.CLOSE_BUTTONS[i].addEventListener('click', this.closeModal.bind(this))
      }
    }

    // Close on escape
    document.addEventListener('keydown', (e) =>
      (e.key === 'Escape' && this.ELEMENT.classList.contains('mtt-modal--show'))
        ? this.closeModal()
        : ''
    )
  }

  openModal (e) {
    e.preventDefault()
    this.ELEMENT.classList.add('mtt-modal--show')
  }

  closeModal () {
    this.ELEMENT.classList.remove('mtt-modal--show')
  }
}
